import loadable from '@loadable/component';

export const AsyncOneTimeTokenLogin = loadable(
  () => import('pages/Login/LegacyOneTimeTokenLogin'),
);
